import { z } from 'zod';
export const submitBugReportSchema = z.object({
    email: z.string().email().max(254).optional().or(z.literal('')),
    title: z.string().min(5).max(200),
    description: z.string().min(10).max(5000),
    pageUrl: z.string().url(),
    screenshot: z.string().optional(),
    browserInfo: z.string(),
    viewportSize: z.string(),
    userAgent: z.string(),
    turnstileToken: z.string(),
});
//# sourceMappingURL=api.js.map